import React from 'react';
import { Lang, ROUTES, DATA_KEYS } from 'shared/constants';
import { Popup } from '../../../components/common';
import { AuthPage } from '../auth-page-wrapper';
import { useFormik } from 'formik';
import styles from './not-allowed.module.scss';
import { notAllowedSSchema } from 'shared/schemas/user.schemas';
import UserService from 'shared/services/user.service';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextInput } from 'src/components/design-system/forms';
import { Button } from 'src/components/design-system/buttons';
import { Col, Row, Input } from 'antd';
import { NavLink } from 'react-router-dom';
import { OAuthFooter } from '../oauth';
const { NOT_ALLOWED } = DATA_KEYS;

const NotAllowedPage = React.memo(({ lang = Lang.NOT_ALLOWED }) => {
  const [error, setError] = React.useState(null);
  const [loading, setLoadingState] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location?.state?.email || '';

  const contactUs = React.useCallback(async values => {
    setError('');
    setLoadingState(true);

    let res = await UserService.contactUs(values);

    setLoadingState(false);

    if (res?.error) {
      setError(res.error);
    } else {
      setSuccess(true);
    }
  }, []);

  const onFinish = () => {
    navigate(ROUTES.WELCOME);
  };

  const { handleChange, handleBlur, handleSubmit, values, errors, touched, isValid } = useFormik({
    validationSchema: notAllowedSSchema,
    initialValues: { email, fullName: '', organization: '', details: '' },
    onSubmit: contactUs,
  });

  return (
    <AuthPage title={lang.HEADER} content={lang.CONTENT}>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col span={24}>
            <TextInput
              type="email"
              name="email"
              value={values.email}
              error={errors.email}
              touched={touched.email}
              onChange={handleChange}
              onBlur={handleBlur}
              autoFocus={true}
              placeholder={lang.EMAIL_PLACEHOLDER}
            />
          </Col>
        </Row>
        <Row gutter={8}>
          <Col md={12} xs={24}>
            <TextInput
              type="text"
              name="fullName"
              value={values.fullName}
              error={errors.fullName}
              touched={touched.fullName}
              onChange={handleChange}
              onBlur={handleBlur}
              autoFocus={true}
              placeholder={lang.FULL_NAME_PLACEHOLDER}
            />
          </Col>
          <Col md={12} xs={24}>
            <TextInput
              type="text"
              name="organization"
              value={values.organization}
              error={errors.organization}
              touched={touched.organization}
              onChange={handleChange}
              onBlur={handleBlur}
              autoFocus={true}
              placeholder={lang.ORGANIZATION_PLACEHOLDER}
            />
          </Col>
          <Col span={24}>
            <div style={{ marginBottom: '24px' }}>
              <Input.TextArea
                name="details"
                value={values.details}
                error={errors.details}
                touched={touched.details}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={lang.ISSUE_DESCRIPTION_PLACEHOLDER}
                autoSize={{ minRows: 1.75, maxRows: 1 }}
                size="large"
                style={{
                  borderRadius: '8px',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  resize: 'none',
                }}
              />
            </div>
          </Col>
        </Row>

        <Button disabled={!isValid} htmlType="submit" loading={loading}>
          {lang.SEND_MY_DETAILS}
        </Button>

        <p className={styles.redirect}>
          <NavLink to={ROUTES.WELCOME}>Try login in with a different email</NavLink>
        </p>

        <div>{error && <span>{error}</span>}</div>
      </form>
      <OAuthFooter loading={loading} />
      <Popup isOpen={success}>
        <h1>{lang.SUCCESS_TITLE}</h1>
        <p className={styles.successContent}>{lang.SUCCESS_CONTENT}</p>
        <Button onClick={onFinish} type="primary" data-key={NOT_ALLOWED.ACCEPT_BUTTON}>
          {lang.SUCCESS_BUTTON}
        </Button>
      </Popup>
    </AuthPage>
  );
});

export { NotAllowedPage };
